import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Moment from 'moment-jalali';
import './assets/styles/magic-checkbox/magic-check.scss';
/*import 'bootstrap-v4-rtl/dist/css/bootstrap.min.css';*/
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import 'bootstrap-v4-rtl/dist/js/bootstrap.min';
import VueNoty from 'vuejs-noty';
import ToggleButton from "vue-js-toggle-button";
import axios from "axios";
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'

Vue.use(BootstrapVue);
Vue.mixin({
    methods: {
        arrayToString(array, delimiter) {
            let string = "";
            for (let item of array) {
                if (string === "") {
                    string = item.toString();
                } else {
                    string += delimiter + item.toString();
                }
            }
            return string;
        },
        stringToArray(string, delimiter, isInt = false) {
            if (isInt) {
                return string.split(delimiter).map((item) => {
                    return parseInt(item);
                });
            } else {
                return string.split(delimiter);
            }
        },
        removeComma(string) {
            return string.replace(/,/g, '');
        },
        unbind(object) {
            return JSON.parse(JSON.stringify(object));
        },
        redirectTo(name) {
            if (localStorage.getItem("token_mobile") === null) {
                this.$router.push({name: 'login'});
            } else {
                this.$router.push({name: `${name}`});
            }
        },
        openModal(id) {
            $(`#${id}`).modal('show');
        },
        commafy( num ) {
            var str = num.toString().split('.');
            if (str[0].length >= 5) {
                str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
            }
            if (str[1] && str[1].length >= 5) {
                str[1] = str[1].replace(/(\d{3})/g, '$1 ');
            }
            return str.join('.');
        },
        removeDuplicatesFromString(string, delimiter) {
            let arr = this.stringToArray(string, delimiter);
            return this.arrayToString([...new Set(arr)], delimiter);
        },
        generateUuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        validateImageUrl(img) {
            if (img !== undefined) {
                return localStorage.getItem("BASE_URL") + "/" + img;
            }
        },
        noImageUrl() {
            return localStorage.getItem("BASE_URL") + "/images/placeholder.png" ;
        },
        thousandSeprator3(a) {
            let amount = a;
            let showprice = "";

            if (amount !== '' && amount !== undefined && amount !== 0 && amount !== '0' && amount !== null) {
                showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                showprice = amount;
            }
            return showprice;
        },
        checkVoucherDateInSalemali(voucherDate){
            console.log(voucherDate)
            let st = localStorage.getItem("salemali_start");
            let end = localStorage.getItem("salemali_end");
            console.log(st !== null)
            console.log(st !== "null")
            console.log(st !== "")
            if (st !== "null" && end !== "null") {
                if (voucherDate === undefined || voucherDate === null ||voucherDate === "" || voucherDate === "0001-01-01") {
                    let tod = Moment(new Date()).format('YYYY-MM-DD');
                    if (tod > end || tod < st) {
                        confirm("تاریخ سند خارج از سال مالی انتخاب شده میباشد.\n" +
                            "امکان ثبت سند وجود ندارد");
                        return false;
                    } else {
                        return true;
                    }
                }else {
                    if (voucherDate > end || voucherDate < st) {
                        confirm("تاریخ سند خارج از سال مالی انتخاب شده میباشد.\n" +
                            "امکان ثبت سند وجود ندارد");
                        return false;
                    } else {
                        return true;
                    }
                }
            } else {
                return true;
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        try {
            $(".modal").modal('hide');
        } catch(e) {}
        next();
    },
});

Vue.use(VueNoty, {
    layout: 'topRight',
    theme: 'metroui'
});

Vue.use(ToggleButton);

Vue.filter('formatGregorianDateToJalaali', function(val) {
    return Moment(val).format('jDD jMMMM jYYYY - HH:mm');
});

Moment.loadPersian({dialect: 'persian-modern'});

Vue.config.productionTip = false;

axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    // Do something with response error
    if (error.response.status === 401) {
        /*localStorage.removeItem("phoneNumber");
        localStorage.removeItem("token_mobile");
        localStorage.removeItem("isRegistered");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("userId");
        delete axios.defaults.headers.common['Authorization'];*/
        localStorage.removeItem("companyName");
        router.push({path: '/login', query: {unauthorized: true}});
    }
    return Promise.reject(error.response);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
